import { Cpu, Leaf, Wrench, ScanLine, Gauge, Settings, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/brand";

const ICONS = { Cpu, Leaf, Wrench, ScanLine, Gauge, Settings };

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#050505] py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-yellow-500" />
              <span className="text-yellow-500 text-xs uppercase tracking-[0.4em]">
                01 — Prestations
              </span>
            </div>
            <h2 className="font-display text-white text-5xl md:text-6xl lg:text-7xl leading-[0.95]">
              Notre savoir-faire,
              <br />
              <span className="text-stroke-yellow">votre performance.</span>
            </h2>
          </div>
          <p className="text-zinc-400 text-base md:text-lg max-w-md">
            Cinq spécialités, une seule obsession&nbsp;: tirer le meilleur de votre
            véhicule, sans compromettre sa fiabilité.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-5">
          {SERVICES.map((service, idx) => {
            const Icon = ICONS[service.icon];
            // Bento grid layout for 6 cards: 4+2 / 3+3 / 3+3
            const span =
              idx === 0
                ? "md:col-span-4"
                : idx === 1
                ? "md:col-span-2"
                : "md:col-span-3";
            return (
              <article
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className={`group relative ${span} bg-[#0d0d0d] border border-white/10 hover:border-yellow-500/70 p-8 md:p-10 transition-all duration-300 overflow-hidden min-h-[260px] flex flex-col justify-between`}
              >
                {/* Decorative number */}
                <div className="absolute top-4 right-6 font-display text-zinc-800 text-7xl select-none">
                  {String(idx + 1).padStart(2, "0")}
                </div>

                <div>
                  <div className="w-12 h-12 border border-yellow-500/60 flex items-center justify-center mb-6 group-hover:bg-yellow-500 transition-colors">
                    <Icon className="w-5 h-5 text-yellow-500 group-hover:text-black transition-colors" />
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl text-white tracking-wide mb-2">
                    {service.title}
                  </h3>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-yellow-500 mb-4">
                    {service.short}
                  </div>
                  <p className="text-zinc-400 text-sm md:text-base leading-relaxed max-w-md">
                    {service.description}
                  </p>
                </div>

                <ul className="mt-6 flex flex-wrap gap-2">
                  {service.bullets.map((b) => (
                    <li
                      key={b}
                      className="text-[11px] uppercase tracking-wider text-zinc-300 border border-white/10 px-3 py-1"
                    >
                      {b}
                    </li>
                  ))}
                </ul>

                <ArrowUpRight className="absolute bottom-6 right-6 w-5 h-5 text-zinc-600 group-hover:text-yellow-500 group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
